<template>
    <div v-if="form">
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>เลขที่ใบแจ้งหนี้</label></b-col
            >
            <b-col sm="6"
                ><input
                    class="form-control"
                    v-model="form.invoice_id"
                    type="text"
                    disabled
            /></b-col>
        </b-row>
        <br />
        <template v-if="form.order_id">
            <b-row sm="10">
                <b-col sm="4" class="col text-right"
                    ><label>เลขใบจอง</label></b-col
                >
                <b-col sm="6"
                    ><input
                        class="form-control"
                        v-model="form.order_id"
                        type="text"
                        disabled
                /></b-col>
            </b-row>
            <br />
        </template>
        <b-row sm="11">
            <b-col sm="4" class="col text-right"
                ><label>วันที่ออกใบแจ้งหนี้</label></b-col
            >
            <b-col sm="6"
                ><input
                    class="form-control"
                    type="text"
                    v-model="form.created_at"
                    disabled
            /></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right"><label>เซลล์</label></b-col>
            <b-col sm="6"
                ><input
                    class="form-control"
                    type="text"
                    v-model="form.sale_id"
                    disabled
            /></b-col>
        </b-row>
        <br />
        <b-row sm="10" v-if="form.customer">
            <b-col sm="4" class="col text-right"
                ><label>รหัสลูกค้า</label></b-col
            >
            <b-col sm="6"
                ><input
                    class="form-control"
                    v-model="form.customer.customer_id"
                    type="text"
                    disabled
            /></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>ยอดขาย</label></b-col>
            <b-col sm="6"
                ><input
                    class="form-control"
                    type="text"
                    v-model="form.total"
                    disabled
            /></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>สถานะ</label></b-col>
            <b-col sm="6">
                <b-form-select v-model="form.invoice_status_id"
                               :options="InvoiceStatus">
                </b-form-select>
            </b-col>
        </b-row>
        <br />
        <b-row sm="10"
               v-show="form.invoice_status_id!==null && form.invoice_status_id === 3"
        >
            <b-col sm="4" class="col text-right"><label>หมายเหตุ</label></b-col>
            <b-col sm="6">
                <input
                    class="form-control"
                    v-model="form.note"
                />
            </b-col>
        </b-row>
        <br />
        <b-row>
            <div class="col text-center">
                <button
                    type="button"
                    class="btn btn-success"
                    @click="saveInvoice">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="goToInvoiceList">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
         <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "invoice-status-modal",
    created() {
        this.$store.dispatch("Common/setInvoiceStatus");
    },
    data() {
        return {
            create_date: ""
        };
    },
    computed: {
        ...mapState({
            InvoiceStatus: state => {
                return [
                    ...state.Common.invoice_status
                        .filter(status => status.id !== 1)
                        .map(status => ({
                            value: status.id,
                            text: status.name
                        }))
                ];
            },
            form: state => {
                return state.Invoice.invoiceForm;
            }
        })
    },
    methods: {
        saveInvoice() {
            this.form.reopen_status = 0;
            this.$emit('submit',this.form);
        },
        goToInvoiceList() {
            this.$emit("submit", "cancel");
        }
    }
};
</script>

<style scoped></style>
